/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import {
  APPLICATION_STATUS_BASE,
  APPLICATION_STATUS_CONCERN_SUMMARY,
  APPLICATION_STATUS_DOCUMENTS,
  APPLICATION_STATUS_DONE,
  APPLICATION_STATUS_EMPLOYMENT_RELATIONSHIP,
  APPLICATION_STATUS_INSURANCE,
  APPLICATION_STATUS_POWER_OF_ATTORNEY,
  APPLICATION_STATUS_REFINEMENT,
  APPLICATION_STATUS_SUMMARY,
} from "./applicationStatus";
import React from "react";
import { Navigate } from "react-router";
import ProgressBar from "@/src/components/ProgressBar/ProgressBar";
import progressBarsteps from "./progressBarSteps";
import SummaryHintBox from "@/src/components/Form/Common/SummaryHintBox";
import PowerOfAttorney from "@/src/components/Form/LitigationCase/PowerOfAttorney";
import Insurance from "@/src/components/Form/Common/Insurance/Insurance";
import Summary from "@/src/components/Form/CivilServiceLaw/Summary";
import HintBox from "@/src/components/Box/HintBox/HintBox";
import { getCaseLink } from "@/src/services/productService";
import { FormSteps } from "@/src/types/FormServiceBase";
import PowerOfAttorneyIntroHintBox from "@/src/components/Form/LitigationCase/PowerOfAttorneyIntroHintBox";
import Base from "@/src/components/Form/CivilServiceLaw/Base";
import Refinement from "@/src/components/Form/Common/AiAssessment/Refinement";
import ConcernSummary from "@/src/components/Form/Common/AiAssessment/ConcernSummary";
import { DocumentsForm } from "@/src/components/Form/DocumentsForm/DocumentsForm";
import EmploymentRelationship from "@/src/components/Form/CivilServiceLaw/EmploymentRelationship";

const formSteps: FormSteps = {
  [APPLICATION_STATUS_BASE]: {
    title: "Antrag - Ihr Anliegen | Legalbird",
    applicationStatus: APPLICATION_STATUS_BASE,
    stepUrl: "anliegen",
    render: (props) => (
      <>
        <HintBox headline={"Wir kümmern uns um Ihr Anliegen!"}>
          Schildern Sie uns bitte kurz Ihr <strong>dienstrechtliches</strong> Anliegen anhand der folgenden Fragen. Jede Information hilft uns, Sie
          bestmöglich zu beraten und direkt die passenden Schritte – wie Widerspruch oder Akteneinsicht – einzuleiten. Sollten Sie bei einer Frage unsicher
          sein, machen Sie sich keine Sorgen: Sie haben zusätzlich die Möglichkeit, Ihren Fall frei aus Ihrer Sicht zu schildern.
        </HintBox>
        <ProgressBar steps={progressBarsteps} active={"concern"} progress={15} />
        <Base {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_EMPLOYMENT_RELATIONSHIP]: {
    title: "Antrag - Informationen zum Anliegen | Legalbird",
    applicationStatus: APPLICATION_STATUS_EMPLOYMENT_RELATIONSHIP,
    stepUrl: "angaben-zum-dienstverhaeltnis",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"concern"} progress={15} />
        <EmploymentRelationship {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_REFINEMENT]: {
    title: "Antrag - Rückfragen | Legalbird",
    applicationStatus: APPLICATION_STATUS_REFINEMENT,
    stepUrl: "rueckfragen",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"concern"} progress={15} />
        <Refinement {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_CONCERN_SUMMARY]: {
    title: "Antrag - Zusammenfassung | Legalbird",
    applicationStatus: APPLICATION_STATUS_CONCERN_SUMMARY,
    stepUrl: "zusammenfassung",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"concern"} progress={15} />
        <ConcernSummary {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DOCUMENTS]: {
    title: "Antrag - Unterlagen | Legalbird",
    applicationStatus: APPLICATION_STATUS_DOCUMENTS,
    stepUrl: "unterlagen",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"documents"} progress={50} />
        <DocumentsForm product={props.product} submitProps={props.submitProps} />
      </>
    ),
  },
  [APPLICATION_STATUS_INSURANCE]: {
    title: "Antrag - Versicherung | Legalbird",
    applicationStatus: APPLICATION_STATUS_INSURANCE,
    stepUrl: "versicherung",
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"insurance"} progress={80} />
        <Insurance {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_SUMMARY]: {
    title: "Antrag - Überprüfen | Legalbird",
    applicationStatus: APPLICATION_STATUS_SUMMARY,
    stepUrl: "ueberpruefen",
    render: (props) => (
      <>
        <SummaryHintBox />
        <Summary {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_POWER_OF_ATTORNEY]: {
    title: "Antrag - Vollmacht | Legalbird",
    applicationStatus: APPLICATION_STATUS_POWER_OF_ATTORNEY,
    stepUrl: "vollmacht",
    render: (props) => (
      <>
        <PowerOfAttorneyIntroHintBox {...props} />
        <PowerOfAttorney {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DONE]: {
    title: "Mein Vertrag | Legalbird",
    applicationStatus: APPLICATION_STATUS_DONE,
    stepUrl: "mein-vertrag",
    render: ({ product }) => <Navigate to={getCaseLink(product)} />,
  },
};

export default formSteps;
